import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useNonProfitProviderConfirmSchema = () => {
  const { t } = useTranslation();

  return z.object({
    personalCode: z
      .string({
        required_error: t(
          "nonProfitProviders.confirmModal.form.fields.personalCode.errors.required",
        ),
      })
      .trim()
      .min(
        1,
        t(
          "nonProfitProviders.confirmModal.form.fields.personalCode.errors.required",
        ),
      ),
  });
};
